import React, { useContext, useState } from 'react';
import { CustomerContext } from '../CustomerContext';
import { Error } from '@app/shared';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '@app/utilities';

export default function CreateCustomer() {
  const navigate = useNavigate();
  const [error, setError] = useState(undefined as string);
  const { customerInformationService } = useContext(CustomerContext);
  const [submitting, setSubmitting] = useState(false as boolean);
  const [externalId, setExternalId] = useState(undefined as string);
  const [title, setTitle] = useState(undefined as string);
  const [givenName, setGivenName] = useState(undefined as string);
  const [middleName, setMiddleName] = useState(undefined as string);
  const [familyName, setFamilyName] = useState(undefined as string);
  const [suffix, setSuffix] = useState(undefined as string);
  const [dateOfBirth, setDateOfBirth] = useState(new Date() as Date);

  const onCreateCustomer = async (e) => {
    try {
      e.preventDefault();
      setSubmitting(true);
      let response = await customerInformationService.createCustomer(
        externalId,
        title,
        givenName,
        middleName,
        familyName,
        suffix,
        dateOfBirth
      );
      navigate(`/customers/${response.customerId}`);
    } catch (error) {
      setError(JSON.stringify(error));
      setSubmitting(false);
    }
  };

  return (
    <section>
      <h1>Create Customer</h1>
      <Error error={error} />
      <form className="ui form" onSubmit={(e) => onCreateCustomer(e)}>
        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">ExternalId</div>
            <input
              type="text"
              value={externalId || ''}
              onChange={(e) => setExternalId(e.target.value)}
              disabled={submitting}
              placeholder="Enter External ID"
            />
          </div>
        </div>

        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Title</div>
            <input type="text" value={title || ''} onChange={(e) => setTitle(e.target.value)} disabled={submitting} />
          </div>
        </div>

        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Given Name *</div>
            <input
              type="text"
              required
              value={givenName || ''}
              onChange={(e) => setGivenName(e.target.value)}
              disabled={submitting}
            />
          </div>
        </div>

        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">MiddleName</div>
            <input
              type="text"
              value={middleName || ''}
              onChange={(e) => setMiddleName(e.target.value)}
              disabled={submitting}
            />
          </div>
        </div>

        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Family Name *</div>
            <input
              type="text"
              required
              value={familyName || ''}
              onChange={(e) => setFamilyName(e.target.value)}
              disabled={submitting}
            />
          </div>
        </div>

        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Suffix</div>
            <input type="text" value={suffix || ''} onChange={(e) => setSuffix(e.target.value)} disabled={submitting} />
          </div>
        </div>

        <div className="field">
          <div className="ui labeled input">
            <div className="ui label">Date of Birth *</div>
            <input
              type="date"
              onKeyDown={(e) => e.preventDefault()}
              value={formatDate(dateOfBirth, 'yyyy-MM-dd')}
              onChange={(e) => setDateOfBirth(e.target.valueAsDate)}
              disabled={submitting}
            />
          </div>
        </div>

        <button className={`ui button primary ${submitting && 'loading'}`} type="submit">
          Create Customer
        </button>
      </form>
    </section>
  );
}
